module.exports = __webpack_public_path__ + "assets/85a1430cfac96213162edac54a1c7ac7.mp3";